export default __webpack_public_path__ + "static/media/my-body-plan-bg.0216171f.png";